import { Component, inject, input, OnInit, signal } from '@angular/core';
import { AutomataOperationsService, Automation } from '@vendasta/automata';
import { AUTOMATION_CONTEXT_INJECTION_TOKEN, AUTOMATION_NAMESPACE_INJECTION_TOKEN$ } from '@galaxy/automata/shared';
import { switchMap, take } from 'rxjs/operators';
import { tap } from 'rxjs';
import { CommonModule, DatePipe } from '@angular/common';
import { MatListModule } from '@angular/material/list';
import { MatIconModule } from '@angular/material/icon';
import { TranslateModule } from '@ngx-translate/core';
import { GalaxyLoadingSpinnerModule } from '@vendasta/galaxy/loading-spinner';
import { RouterLink } from '@angular/router';
import { SnackbarService } from '@vendasta/galaxy/snackbar-service';

@Component({
  selector: 'ai-incoming-automations',
  templateUrl: './ai-incoming-automations.component.html',
  styleUrls: ['./ai-incoming-automations.component.scss'],
  imports: [
    CommonModule,
    MatListModule,
    MatIconModule,
    TranslateModule,
    DatePipe,
    GalaxyLoadingSpinnerModule,
    RouterLink,
  ],
})
export class AiIncomingAutomationsComponent implements OnInit {
  automataOperationsService = inject(AutomataOperationsService);
  automationContext = inject(AUTOMATION_CONTEXT_INJECTION_TOKEN);
  namespace$ = inject(AUTOMATION_NAMESPACE_INJECTION_TOKEN$);
  snackbarService = inject(SnackbarService);

  employeeId = input<string>('');
  disableNavigation = input(false);
  automations = signal([] as Automation[]);
  hasMore = signal(false);
  loading = signal(false);
  pageSize = 10;
  cursor = '';

  ngOnInit() {
    this.loadMoreAutomations();
  }

  loadMoreAutomations() {
    if (this.loading()) {
      return;
    }
    this.namespace$
      .pipe(
        tap(() => this.loading.set(true)),
        take(1),
        switchMap((namespace) =>
          this.automataOperationsService.listAutomationsByEmployee(
            namespace,
            this.automationContext,
            {
              employeeId: this.employeeId(),
            },
            this.pageSize,
            this.cursor,
          ),
        ),
      )
      .subscribe({
        next: (resp) => {
          this.automations.set([...this.automations(), ...(resp?.results || [])]);
          this.hasMore.set(resp?.hasMore);
          this.cursor = resp?.nextCursor || '';
        },
        error: (err) => {
          this.snackbarService.openErrorSnack('AI_ASSISTANT.SETTINGS.ERROR_LOADING_AUTOMATIONS');
          console.error('Error loading automations:', err);
        },
        complete: () => {
          this.loading.set(false);
        },
      });
  }
}
